export default __webpack_public_path__ + "static/6756-3ca76351984f69cdc51ceb625d0c410c.jpg";